import linspace from 'linspace';
import quantile from 'distributions-lognormal-quantile';
import pdf from 'distributions-lognormal-pdf';
import cdf from 'distributions-lognormal-cdf';

const getMean = (mu, sigma) => {
  return Math.exp(mu + ((sigma ** 2) / 2));
};

const getMedian = (mu) => {
  return Math.exp(mu);
};

const getVariance = (mu, sigma) => {
  const s2 = sigma ** 2;
  return (Math.exp(s2) - 1) * Math.exp((2 * mu) + s2);
};

const getLogX = (low, high, n) => {
  return linspace(Math.log(low), Math.log(high), n).map(x => Math.exp(x));
};

const getDistLognormalMuSigma = (mu, sigma, n = 100) => {
  const lowXHighX = quantile([0.000001, 0.9999], { mu, sigma });
  const logX = getLogX(lowXHighX[0], lowXHighX[1], n);
  const PDF = pdf(logX, { mu, sigma });
  const CDF = cdf(logX, { mu, sigma });
  return {
    X: logX,
    pdf: PDF,
    cdf: CDF,
    mean: getMean(mu, sigma),
    median: getMedian(mu),
    variance: getVariance(mu, sigma),
  };
};

const getDistLognormalMeanErrorFactor = (mean, errorFactor, n = 200) => {
  const sigma = Math.log(errorFactor) / 1.64485;
  const mu = Math.log(mean) - ((sigma ** 2) / 2);
  return getDistLognormalMuSigma(mu, sigma, n);
};

const getDistLognormalMedianErrorFactor = (median, errorFactor, n = 100) => {
  const sigma = Math.log(errorFactor) / 1.64485;
  const mu = Math.log(median);
  return getDistLognormalMuSigma(mu, sigma, n);
};

const getDistLognormalPercentile = (fifth, ninetyFifth, n = 100) => {
  const sigma = Math.log(ninetyFifth / fifth) / (2 * 1.64485);
  const mu = Math.log(ninetyFifth / 1.64485) - (ninetyFifth * sigma);
  return getDistLognormalMuSigma(mu, sigma, n);
};

export {
  getDistLognormalMedianErrorFactor,
  getDistLognormalMeanErrorFactor,
  getDistLognormalPercentile,
};
